import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { classes, style } from 'typestyle'

import { withRouter } from '../../../contexts/with-router'

/* Contents ===================================================================================== */
import { GLOBAL_CONTENTS } from '../../../common/global-contents'

/* Hooks ======================================================================================== */
import useFetch from '../../../hooks/use-fetch'
import useLocal from '../../../hooks/use-local'

/* Components =================================================================================== */
import { Box } from '../../../components/box/box.component'
import { Button } from '../../../components/button'
import { EvenMoreSimplerPagination } from '../../navigation/pagination'
import { Line } from '../../../components/line'
import { Modal } from '../../../components/modal'
import { Notification } from '../../../components/notification'
import { Tabs, Tab } from '../../../components/tab'
import { Text } from '../../../components/text/text.component'

/* Styles ======================================================================================= */
import { paddingLeftInner } from '../../../styles/default/padding'
import { pb8 } from '../../../styles/styleset/padding/pb8'
import { portalClass } from './index.class'
import { pt8 } from '../../../styles/styleset/padding/pt8'
import { f16i } from '../../../styles/styleset/font-size/f16i'
import { mb8 } from '../../../styles/styleset/margin/mb8'
import { b0 } from '../../../styles/styleset/bottom/b0'
import { h100 } from '../../../styles/styleset/height/h100'

export const Portal = withRouter((props: any) => {
  const { handleContentClick, isDialog = true, onBookmarkDelete } = props

  const [local] = useLocal()
  const [bookmarks, $bookmarks] = useFetch(
    { data: [] },
    { url: `${process.env.REACT_APP_API_URL}/c/bookmarks`, search: { page: 1 } },
  )
  const [, $bookmark] = useFetch(
    { data: [] },
    { url: `${process.env.REACT_APP_API_URL}/a/bookmarks` },
  )
  const [groups, $groups] = useFetch(
    { data: [] },
    { url: `${process.env.REACT_APP_API_URL}/a/groups` },
  )

  const { base, baseInner, borderBottom, baseTable } = portalClass.setProps({})

  useEffect(() => {
    if (bookmarks.mounted) {
      $bookmarks.get({ search: { page: 1 } })
    }
  }, [bookmarks.mounted])

  useEffect(() => {
    if (groups.mounted) {
      $groups.get()
    }
  }, [groups.mounted])

  return (
    <Box className={base} baseline="none" onClick={handleContentClick} rounded row fullHeight>
      <Box className={baseInner} baseline="none" rounded fullHeight>
        <Tabs allowIndex={false} className={style({ height: 'calc(100% - 49px)' })}>
          <Tab label={GLOBAL_CONTENTS.myBookmarks[local]} className={h100}>
            <Box row spaceBetween alignCenterX relative fullHeight>
              <Box row fullWidth>
                <Box className={classes(paddingLeftInner, pt8, pb8, borderBottom)}>
                  <Text size="sm" semiBold>
                    {GLOBAL_CONTENTS.page[local]}
                  </Text>
                </Box>
                {bookmarks.payload.data.length > 0 &&
                  bookmarks.payload.data.map((row: any, key: any) => {
                    return (
                      <Box
                        className={classes(
                          paddingLeftInner,
                          pt8,
                          pb8,
                          key < bookmarks.payload.data.length - 1 && borderBottom,
                        )}
                        key={key}
                        flex
                        alignCenterY
                        spaceBetween
                      >
                        <Box alignCenterY fullHeight>
                          <Link to={row.body.url} onClick={isDialog && Modal.pop}>
                            <Text link size="sm">{`${row.body.title}`}</Text>
                          </Link>
                        </Box>
                        <Button
                          baseline="none"
                          size="sm"
                          icon={<i className={classes('material-icons', f16i)}>close</i>}
                          onClick={() => {
                            $bookmark.post({ body: { url: row.body.url } }).then((payload: any) => {
                              $bookmarks.get()
                              if (Object.keys(payload).length) {
                                Notification.push({
                                  label: GLOBAL_CONTENTS.bookmarkAdded[local],
                                })
                              } else {
                                Notification.push({
                                  label: GLOBAL_CONTENTS.bookmarkRemoved[local],
                                })
                              }
                              onBookmarkDelete()
                            })
                          }}
                        />
                      </Box>
                    )
                  })}
                {bookmarks.mounted &&
                  !bookmarks.meta.isLoading &&
                  bookmarks.payload.data.length === 0 && (
                    <Box className={classes(paddingLeftInner, pt8, pb8)}>
                      <Text size="sm" italic>
                        {GLOBAL_CONTENTS.noBookmarks[local]}
                      </Text>
                    </Box>
                  )}
              </Box>
              {bookmarks.mounted && !bookmarks.meta.isLoading && bookmarks.payload.data.length > 0 && (
                <Box baseline="none" sticky className={classes(b0, pb8)} fullWidth alignCenterX row>
                  <Line className={mb8} />
                  <EvenMoreSimplerPagination data={bookmarks} $data={$bookmarks} />
                </Box>
              )}
            </Box>
          </Tab>
          <Tab label={GLOBAL_CONTENTS.myGroups[local]} className={pb8}>
            <Box row>
              <table className={baseTable}>
                <thead className={borderBottom}>
                  <tr>
                    <td className={classes(paddingLeftInner, pt8, pb8)}>
                      <Text size="sm" semiBold>
                        {GLOBAL_CONTENTS.groupName[local]}
                      </Text>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {groups.payload.data.length > 0 &&
                    groups.payload.data.map((row: any, key: any) => {
                      return (
                        <tr
                          className={classes(key < groups.payload.data.length - 1 && borderBottom)}
                          key={key}
                        >
                          <td className={classes(paddingLeftInner, pt8, pb8)}>
                            <Link to={row.to} onClick={isDialog && Modal.pop}>
                              <Text size="sm" link>{`${row.body?.generalInformation?.name ||
                                row.body.name}`}</Text>
                            </Link>
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
              {groups.mounted && !groups.meta.isLoading && groups.payload.data.length === 0 && (
                <Box className={classes(paddingLeftInner, pt8, pb8)}>
                  <Text size="sm" italic>
                    {GLOBAL_CONTENTS.noGroups[local]}
                  </Text>
                </Box>
              )}
            </Box>
          </Tab>
        </Tabs>
      </Box>
    </Box>
  )
})
